import React, { useCallback, useEffect, useState } from 'react';
import { GetCampaignKpiCards } from '../../../../../Services/PerformanceInsights/CampaignInsightsService';

const useFetchCampaignKpiCards = (body) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setIsError(false);
    setError(null);
    try {
      const result = await GetCampaignKpiCards(body);
      setData(result);
    } catch (err) {
      setIsError(true);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [body]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, isError, error };
};

export default useFetchCampaignKpiCards;
